"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function DevBracketsIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m6.892,19.097L.399,12.604c-.159-.159-.249-.375-.249-.601s.09-.441.249-.601l6.494-6.494,1.202,1.202-5.893,5.893,5.893,5.892-1.202,1.202Z" }),
        react_1.default.createElement("path", { d: "m17.108,19.097l-1.202-1.202,5.892-5.892-5.892-5.893,1.202-1.202,6.493,6.494c.332.332.332.87,0,1.202l-6.493,6.493Z" })));
}
exports.default = DevBracketsIcon;
